import script from "./Company.vue?vue&type=script&lang=ts&setup=true"
export * from "./Company.vue?vue&type=script&lang=ts&setup=true"

import "./Company.vue?vue&type=style&index=0&id=22ac9c5d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ac9c5d"]])

export default __exports__